export const CATALOG_ROUTES = {
    LIST: "/settings/catalogs/",
    BRAND_ITEMS: "/settings/catalogs/brands/{id}/",
    NO_BRAND_ITEMS: "/settings/catalogs/{id}/no-brand/",
    ITEM_DETAILS: "/settings/catalogs/items/{id}/",
}
